import { BaseListModel } from "../base/base-list-model";
import { RequestModel } from "./request.model";

export const RequestsListModel = BaseListModel(RequestModel).named("Requests");
